import { QueryBuilderV2 } from 'modules/queryBuilder/legacyQueryBuilder';
import {
  QueryBuilderIndex,
  QueryBuilderV1Props,
} from 'modules/queryBuilder/legacyQueryBuilder/types';
import { stringTypeCatalogQueryComparators } from 'modules/queryBuilder/legacyQueryBuilder/utils/comparators';
import noop from 'utils/noop';
import { CATALOG_COLLECTION_NAME } from '../catalogConstants';
import {
  CATALOG_EMPTY_SEARCH_GROUP,
  CATALOG_EMPTY_SEARCH_QUERY,
  CATALOG_EMPTY_CRITERIA_PROPERTY,
} from '../helpers';
import { useCanManageCatalogs, useTranslation } from '../hooks';

export const CollectionQueryBuilder = (props: Partial<QueryBuilderV1Props>) => {
  const { t } = useTranslation();
  const canManageCatalogs = useCanManageCatalogs();

  return (
    <QueryBuilderV2
      comparatorDropdownProps={{ stringTypeComparators: stringTypeCatalogQueryComparators }}
      emptySearchGroup={CATALOG_EMPTY_SEARCH_GROUP}
      emptySearchQuery={CATALOG_EMPTY_SEARCH_QUERY}
      emptyCriteriaProperty={CATALOG_EMPTY_CRITERIA_PROPERTY}
      hideGroupsOnSingle
      hideProperty
      isLoading={false}
      loadingMessage="Loading..."
      showDynamicFieldToggle
      showLimitAndOrderBy
      sizeLimitMax={50}
      type={CATALOG_COLLECTION_NAME}
      validationMessageHeader={t('catalog.collection.queryValidationError')}
      resetPreviewIdentifier={noop}
      esIndex={QueryBuilderIndex.Catalog}
      {...props}
      canManageCatalogs={canManageCatalogs}
    />
  );
};
